'use strict';

exports.__esModule = true;
exports.getTransition = exports.showTabContent = exports.getRowSize = exports.getSelectedSpecialist = undefined;

var _find2 = require('lodash/find');

var _find3 = _interopRequireDefault(_find2);

var _constants = require('./constants');

var _radium = require('radium');

var _radium2 = _interopRequireDefault(_radium);

var _reactAnimations = require('react-animations');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
	if we find the id we return the sp, either way we return null -> ge them all
**/
var getSelectedSpecialist = exports.getSelectedSpecialist = function getSelectedSpecialist(selectedSpecialist, specialists) {
	if (!selectedSpecialist || !selectedSpecialist.id) {
		return;
	}
	if (selectedSpecialist.id === 'all' || !selectedSpecialist.id || !specialists || !specialists.length) {
		return;
	}
	return (0, _find3.default)(specialists, function (specialist) {
		return specialist.id === selectedSpecialist.id;
	});
};

/**
 * Returns the number of rows of the widget carousel: 4 for the horizontal
 * layout, and 2 for the page layout. Defaults to the page layout.
 * @param {string} layoutType The layout type: horizontal or page.
 * @returns {number} The number of rows of the widget carousel.
 */
var getRowSize = exports.getRowSize = function getRowSize(layoutType) {
	switch (layoutType) {
		case 'horizontal':
			return _constants.HORIZONTAL_ROW_SIZE;
		case 'page':
		default:
			return _constants.PAGE_ROW_SIZE;
	}
};

/**
 * Returns true if the current tab is the first tab.
 * @param {!Array<string>} tabs The tab names.
 * @param {string} currentTab The name of the current tab.
 * @return {boolean} True if the current tab is the first tab.
 */
var isFirstTab = function isFirstTab(tabs, currentTab) {
	return tabs && tabs.length && tabs[0] === currentTab;
};

/**
 * Returns true if the selected tab is valid and its content should be
 * displayed.
 * @param {!Object} props The component props.
 * @param {string} currentTab The name of the current tab.
 * @return {boolean} True if the content of the current tab should be displayed.
 */
var showTabContent = exports.showTabContent = function showTabContent(props, currentTab) {
	if (!(props.tabs && props.tabs.length)) {
		return false;
	}
	if (!props.header) {
		return isFirstTab(props.tabs, currentTab);
	}
	if (props.tabs.includes(props.header.selectedTab)) {
		return props.header.selectedTab === currentTab;
	}
	return isFirstTab(props.tabs, currentTab);
};

/**
 * Returns true going to right. false to go to left
 * @param {!Object} props The component props.
 * @param {string} currentTab The name of the current tab.
 * @return {boolean} True if slide has to go right. False if has to go left.
 */
var getTransition = exports.getTransition = function getTransition(props) {
	/* defaults to right */
	if (!(props.tabs && props.tabs.length)) {
		return {};
	}
	if (props.tabs.indexOf(props.header.selectedTab) > props.tabs.indexOf(props.header.previousTab)) {
		return {
			entering: {
				animation: 'x .5s',
				animationName: _radium2.default.keyframes(_reactAnimations.fadeInLeft, 'fadeInLeft')
			},
			exiting: {

				animation: 'x .5s',
				animationName: _radium2.default.keyframes(_reactAnimations.fadeOutRight, 'fadeOutRight')
			},
			exited: {
				display: 'none'
			},
			entered: {}
		};
	} else {
		return {
			entering: {
				animation: 'x .5s',
				animationName: _radium2.default.keyframes(_reactAnimations.fadeInRight, 'fadeInRight')
			},
			exiting: {
				animation: 'x .5s',
				animationName: _radium2.default.keyframes(_reactAnimations.fadeOutLeft, 'fadeOutLeft')
			},
			exited: {
				display: 'none'
			},
			entered: {}
		};
	}
};